<div class="auth-form-card">
  <div class="auth-form-header">
    <img
      src="/assets/logos/cyflare-one-logo-new-colors.png"
      alt="Cyflare One"
      class="auth-form-logo"
    />
    <h2>Forgot Password</h2>
  </div>

  <form [formGroup]="forgotPasswordForm">
    <p class="auth-form-description">
      Enter the email address associated with your account and we'll send you a link to reset your password.
    </p>

    @if (errorMessage()) {
      <p class="auth-form-error">{{ errorMessage() }}</p>
    }

    <app-error-message></app-error-message>

    <div class="auth-form-field">
      <kendo-floatinglabel text="Your Email Address">
        <input
          kendoTextBox
          class="form-control"
          formControlName="email"
          (input)="onEmailInput($event)"
        />
      </kendo-floatinglabel>
    </div>

    <div class="auth-form-submit">
      <button
        kendoButton
        class="cyflare-btn-primary cyflare-btn-lg cyflare-btn-block"
        type="button"
        [disabled]="!forgotPasswordForm.valid"
        (click)="show()"
      >
        Submit
      </button>
    </div>

    <div class="auth-form-footer">
      <span>Having trouble signing in?</span>
      <a
        href="mailto:support@cyflare.com"
        kendoButton
        fillMode="clear"
      >
        Contact Us
      </a>
    </div>

    <div class="auth-form-secondary">
      <button
        kendoButton
        class="cyflare-btn-secondary cyflare-btn-lg cyflare-btn-block"
        type="button"
        (click)="back()"
      >
        Go Back
      </button>
    </div>
  </form>
</div>
